import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';

// Used to share LinkDirective and UI tagging across multiple components
@NgModule({ declarations: [],
    exports: [], imports: [RouterModule,
        FormsModule], providers: [] })
export class TealiumModule {
}

